<div class="button-wrap">
  <button mat-button type="button" [disabled]="disabled" (click)="onClick()">
    <mat-icon svgIcon="delete"></mat-icon>記録を削除
  </button>
</div>
